import * as React from "react";
import { cn } from "@/app/utils/tw-merge";

export function FieldHint({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      data-slot="field-hint"
      className={cn("text-xs text-muted-foreground leading-snug", className)}
      {...props}
    />
  );
}
